import '../App.css';
import '../scss/App.scss';
import { Box, Container, Grid, Link, Button, TextField, IconButton, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, } from '@mui/material';
import { useEffect, useState, useRef } from 'react';
import axios from 'axios'; // If you're using axios
import { useParams } from 'react-router-dom';
import { Typography } from '@mui/material';


import EditIcon from '@mui/icons-material/Edit';
import SaveIcon from '@mui/icons-material/Save';

const tracks = [
  {
    id: 0,
    title: 'Old Track',
    img: '../assets/treks/old-trek.jpeg',
  },
  {
    id: 1,
    title: 'New Track',
    img: '../assets/treks/new-trek.jpeg',
  },
  {
    id: 2,
    title: 'Helicopter Route',
    img: '../assets/treks/helicopter-route.jpg',
  },
];
function Detail({ onSave }) {

  const [templeData, setTempleData] = useState(null);
  const [weather, setWeather] = useState([]);
  const [timing, setTiming] = useState([]);
  const [aarti, setAarti] = useState([]);
  const [route, setRoute] = useState([]);
  const [peakMonth, setPeakMonth] = useState([]);
  const [offPeakMonth, setOffPeakMonth] = useState([]);
  const [accommodation, setAccommodation] = useState([]);
  
  const [yatraParchi, setYatraParchi] = useState([]);
  const [yatraParchiTitle, setYatraParchiTitle] = useState('');
  const [yatraParchiSubtitle, setYatraParchiSubtitle] = useState('');

  const { id } = useParams();


 


const sections = [
    {
      title: 'Clothing Guidelines',
      content: [
        'Avoid shorts or revealing clothes.',
        'Warm clothes are advisable—even on sunny days.',
        'Late July to Early September: Pack a raincoat and umbrella for surprise showers.',
        'December to January: Bring heavy woollens, wind-cheaters, caps, and gloves for warmth.',
      ],
    },
    {
      title: 'Entry/Exit Information',
      content: [
        'Gate no. 1: Located near Old Gufa – Restricted Access (Not open to the public)',
        'Gate no. 2: VIP Entry and for visitors holding Aarti passes',
        'Gate no. 3: General Public Entry via Skywalk',
        'Gate no. 4: Emergency Use Only – Near Arya Smart Locker on Track (Not open to the public)',
        'Gate no. 5: Exclusive Entry for Defence Personnel – Located near Durga Bhawan',
        'Gate no. 6: Emergency Use Only – Located near Hanuman Mandir (Not open to the public)',
        'Entry and exit through the same gate via separate routes',
      ],
    },
    {
      title: 'Photography/Videography',
      content: ['Not allowed inside bhawan'],
    },
    {
      title: 'Drinking Water & Restrooms',
      content: ['No charges'],
    },
    {
      title: 'VIP Darshan',
      content: [
        'Defence Personnel:\nCost: Complimentary\nPass: Available at the Army counter near Shiv Temple',
        'General Public (Helicopter Yatris Only):\n• Katra–Sanjichhat: ₹1830\n• Sanjichhat–Katra: ₹1830\n• Round Trip: ₹3660',
      ],
    },
    {
      title: 'Locker/Cloak Room',
      content: [
        'Standard lockers are available for free at Ardhkuwari and Bhawan.',
        'Local shops also offer storage for a nominal fee.',
      ],
    },
    {
      title: 'Shoe Storage',
      content: [
        'Available for free at Ardhkuwari and Bhawan.',
        'Local shops also offer storage for a nominal fee.',
      ],
    },
    {
      title: 'Parking',
      content: [
        'Katra Railway Station, ₹50 approx',
      ],
    },

  ];


  const carouselItems = [
    {
      title: "Palki/Palanquin/Sedan Chair",
      note: "(Available onsite)",
      image: "../assets/palki.svg",
      content: [
        {
          title: "Katra – Bhawan – Katra",
          prices: ["₹4000 (up to 100 kg, 4 carriers)", "₹4500 (above 100 kg, 6 carriers)"]
        },
        {
          title: "Katra – Bhawan via Bhairon – Katra",
          prices: ["₹4500 (up to 100 kg, 4 carriers)", "₹5000 (above 100 kg, 6 carriers)"]
        },
        {
          title: "Sanjichhat Helipad – Bhawan",
          prices: ["₹1250 (up to 100 kg, 4 carriers)", "₹1400 (above 100 kg, 6 carriers)"]
        }
      ]
    },
    {
      title: "Pithoos/Porters",
      image: "../assets/service-slider/kedarnath-palki.svg",
      content: [
        "Luggage (up to 25 kg) or Children (up to 6 years)",
        "Katra – Bhawan – Katra: ₹600",
        "Katra to Bhawan: ₹350",
        "Bhawan to Katra via Bhairon: ₹400"
      ]
    },
    {
      title: "Pony/Horse/Mule",
      image: "../assets/service-slider/pony.svg",
      content: [
        {
          title: "Katra to Bhawan",
          prices: ["₹700 (Adult)", "1200 (Adult + Child, 3–6 yrs)"]
        },
        {
          title: "Katra to Adhkuwari or Adhkuwari to Bhawan",
          prices: ["₹380 (Adult)", "₹430 (Adult + Child)"]
        },
        {
          title: "Katra to Sanjichhat",
          prices: ["₹600 (Adult)", "₹675 (Child)"]
        },

      ]
    },


    {
      title: "Pony/Horse/Mule",
      image: "../assets/service-slider/pony.svg",
      content: [

        {
          title: "Bhawan to Katra via Bhairon",
          prices: ["₹850 (Adult)", "₹900 (Adult + Child)"]
        },


        {
          title: "Bhawan to Sanjichhat or Bhawan to Bhairon",
          prices: ["₹275 (Adult)", "₹300 (Adult + Child)"]
        },

        {
          title: "Bhawan to Adhkuwari via Bhairon",
          prices: ["₹425 (Adult)", "₹475 (Adult + Child)"]
        },

      ]
    },
    {
      title: "Helicopter Service",
      image: "../assets/service-slider/vaishno-helicopter.svg",
      content: [
        {
          title: "Katra to Sanjichhat: ₹2320",
          prices: ["(Free for children under 2)"]
        },
        {
          title: "Sanjichhat to Katra: ₹2320",
          prices: ["(Free for children under 2)"]
        },
        {
          title: "Round Trip (Katra–Sanjichhat–Katra): ₹4640",
          prices: ["(Free for children under 2)"]
        },
        {
          title: "Jammu to Bhawan Helicopter Service",
          prices: ["₹72440 Same Day Return and ₹122440 Next Day Return"]
        }
      ]
    },
    
    {
      title: "Cable Car/Ropeway",
      image: "../assets/service-slider/vaishno-cabecar.svg",
      content: ["Route : Bhawan to Bhairo Baba","Fare : ₹100 for above 3 year of age"]
    },
    {
      title: "Bhandara & Prasad Counter",
      image: "../assets/service-slider/vaishno-prasad.svg",
      content: [
        
        {
          title: "Prasad Counter",
          prices: ["Near Holy Cave (Bhawan)", "Hawan Poojan :  adhkuwari ₹3100, Bhawan ₹3100, ₹5100, and ₹11,000", "Attka Aarti : ₹2000 per head. Free for children up to 9 years"]
        }
      ]
    },
    
    {
      title: "Blanket Store",
      image: "../assets/palki.svg",
      content: ["Available for free at a nominal", "refundable security deposit","Location : Vaishnavi Dham (Jammu), Katra Bus Stand, Adhkuwari, Sanjichhat and Bhawan", "Price : Based on item."]
    },
    
  ];

  const weatherImg = [
    {
      image: "../assets/march-june.svg",
    },
    {
      image: "../assets/july-sept.svg",
    },
    {
      image: "../assets/oct-nov.svg",
    },
    {
      image: "../assets/dec-feb.svg",
    },
  ];
  const initialDescription = 'Demo text goes here.';
  const [description, setDescription] = useState(initialDescription);
  const [isEditing, setIsEditing] = useState(false);

  const handleEditClick = () => {
    setIsEditing(true);
  };

  const handleSaveClick = () => {
    setIsEditing(false);
    if (onSave) {
      onSave(description); // Optionally update to API or parent state
    }
  };

 

  const mergedWeather = weather.map((item, index) => ({
    ...item,
    image: weatherImg[index]?.image || "/assets/default-placeholder.svg",
  }));

  const [openModal, setOpenModal] = useState(false);
  const [modalContent, setModalContent] = useState('');

  const getTruncatedText = (text, wordLimit = 24) => {
    const words = text.split(' ');
    if (words.length <= wordLimit) return text;
    return words.slice(0, wordLimit).join(' ') + '...';
  };

  const handleReadMore = (fullText) => {
    setModalContent(fullText);
    setOpenModal(true);
  };


  const packages = [
    {
      title: "Jammu - Bhawan - Jammu (SDR)",
      price: "₹35,000",
      description: "Same Day Return",
      features: [
        "(SDR) Same day return",
        "Transport + Heli (Jammu - Bhawan - Jammu)",
        "Ropeway Ticket",
        "Priority Darshan at Bhawan & Bhairon Ji",
        "Meals",
        "Prasad Box",
        "Transportation is included from the Helipad to the Bhawan and from the Bhawan to the Helipad.",
      ],
    },
    {
      title: "Jammu - Bhawan - Jammu (NDR)",
      price: "₹60,000",
      description: "Next Day Return",
      features: [
        "(NDR) Next day return",
        "Transport + Heli (Jammu - Bhawan - Jammu)",
        "Ropeway Ticket",
        "Priority Darshan at Bhawan & Bhairon Ji",
        "Meals",
        "Prasad Box",
        "SSVP (Shradha Suman Vishesh Pooja)",
        "Accommodation",
        "Transportation is included from the Helipad to the Bhawan and from the Bhawan to the Helipad.",
      ],
    },
  ];
  return (
    <>
      <Box className="innerbanner" >
        <img src="../assets/banner/detail-image.svg" alt="" />
        <Box className="innerContent">
          <h1>Maa Vaishno Devi Temple and Cave</h1>
        </Box>
      </Box>
      <Box className="templeDetailBox">
        <Container maxWidth="md">
          <Grid container spacing={2} justifyContent="center" alignItems="center">
            <Grid size={{ xl: 8, lg: 8, md: 8, sm: 12, xs: 12 }} >
              <Box
                className="detailBoxContent"
                sx={{

                  position: 'relative',
                }}
              >
                <p>Vaishno Devi Temple, also known as the Shri Mata Vaishno Devi Temple and Vaishno Devi Bhawan, is a Hindu mandir (temple) located in Katra, Jammu and Kashmir, dedicated to Vaishno Devi, a manifestation of Durga. It is located on the Trikuta mountain at 5,000 feet elevation. The Shakti tradition considers it to be a Shakti Pitha. The temple is governed by the Shri Mata Vaishno Devi Shrine Board (SMVDSB) and has been chaired by the Government of Jammu and Kashmir since August 1986.</p>
              </Box>
            </Grid>
            <Grid size={{ xl: 4, lg: 4, md: 4, sm: 12, xs: 12 }} >
              <Box className="detailBoxImg rounded-3 overflow-hidden">
                <img src="../assets/vaisno-image.svg" alt="" className='img-fluid rounded-3' />
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>
      <section>
        <Box className="tempratureBox">
          <Container maxWidth="md">
            <Grid container spacing={2} alignItems="center">
              <Grid size={12}>
                <Box className="templeInnerHeading">
                  <h2>Monthly Temperature Guide</h2>
                </Box>
              </Grid>

              <Grid size={{ xl: 3, lg: 3, md: 3, sm: 6, xs: 6 }}>
                <Box className="tempratureContentBox rounded-3 overflow-hidden">
                  <img src="../assets/march-june.svg" alt="" className="w-100 rounded-3" />
                  <h3>
                    March – June
                    <br />
                    <span> 15°C – 30°C</span>
                  </h3>
                </Box>
              </Grid>

              <Grid size={{ xl: 3, lg: 3, md: 3, sm: 6, xs: 6 }}>
                <Box className="tempratureContentBox rounded-3 overflow-hidden">
                  <img src="../assets/july-sept.svg" alt="" className="w-100 rounded-3" />
                  <h3>
                    July – Sept
                    <br />
                    <span>17°C – 30°C</span>
                  </h3>
                </Box>
              </Grid>

              <Grid size={{ xl: 3, lg: 3, md: 3, sm: 6, xs: 6 }}>
                <Box className="tempratureContentBox rounded-3 overflow-hidden">
                  <img src="../assets/oct-nov.svg" alt="" className="w-100 rounded-3" />
                  <h3>
                    Oct – Nov
                    <br />
                    <span>10°C – 20°C</span>
                  </h3>
                </Box>
              </Grid>

              <Grid size={{ xl: 3, lg: 3, md: 3, sm: 6, xs: 6 }}>
                <Box className="tempratureContentBox rounded-3 overflow-hidden">
                  <img src="../assets/dec-feb.svg" alt="" className="w-100 rounded-3" />
                  <h3>
                    Dec – Feb
                    <br />
                    <span>-2°C – 13°C</span>
                  </h3>
                </Box>
              </Grid>

            </Grid>
          </Container>
        </Box>
      </section>
      <section>
        <Box className="tampleTimingBox">
          <Container maxWidth="md">
            <Grid container spacing={2} alignItems="stretch">
              <Grid size={{ xl: 6, lg: 6, md: 6, sm: 12, xs: 12 }} >
                <Box className="tampleTimingImg rounded-3 overflow-hidden">
                  <img src="../assets/tample-timing.svg" className='img-fluid rounded-3' alt="" />
                </Box>
              </Grid>
              <Grid size={{ xl: 6, lg: 6, md: 6, sm: 12, xs: 12 }} >
                <Box className="tampleTimingContent grayBox p-lg-4 rounded-3">
                  <Box className="templeInnerHeading">
                    <h3>Temple Timings</h3>
                  </Box>
                  <ul>
                  <li>
                      Mandir Opening
                      <span>Open round the clock</span>
                    </li>
                    <li>
                      Attka Morning Aarti
                      <span>06:00 am - 07:30 am</span>
                    </li>

                    <li>
                      Attka Evening Aarti
                      <span>07:00 pm - 08:30 pm</span>
                    </li>
                  
                    
                    
                    
                    

                    

                    <li>
                      Gufa Opening
                      <div>
                      <span className='d-block'>11:00 am to 01:00 pm</span>
                      </div>
                    </li>
                    <li>
                      Garbhjoon Morning Aarti
                      <div>
                      <span className='d-block'>06:00 am to 07:30 am</span>
                      </div>
                    </li>
                    <li>
                      Garbhjoon Evening Aarti
                      <div>
                      <span className='d-block'>07:00 pm to 08:30 pm</span>
                      </div>
                    </li>

                    <li>
                      Break Timings
                      <span>During Aarti</span>
                    </li>
                    <li>
                      SSVP opens 60 days ahead
                      <span className='text-end'>₹22,000 per person, <br /> ₹48,000 for two.</span>
                    </li>
                  </ul>
                </Box>
              </Grid>
            </Grid>
            <Grid container spacing={2} alignItems="stretch" className="mt-4">
              <Grid size={{ xl: 3, lg: 3, md: 3, sm: 6, xs: 6 }} >
                <Box className="tampleTimingImg rounded-3 overflow-hidden">
                  <img src="../assets/aarti1.svg" className='img-fluid rounded-3' alt="" />
                </Box>
              </Grid>
              <Grid size={{ xl: 3, lg: 3, md: 3, sm: 6, xs: 6 }} >
                <Box className="tampleTimingImg rounded-3 overflow-hidden">
                  <img src="../assets/aarti2.svg" className='img-fluid rounded-3' alt="" />
                </Box>
              </Grid>
              <Grid size={{ xl: 6, lg: 6, md: 6, sm: 12, xs: 12 }} >
                <Box className="tampleTimingContent grayBox p-lg-4 rounded-3">
                  <Box className="templeInnerHeading">
                    <h3>Aatka Aarti Price</h3>
                  </Box>
                  <ul>
                  <li>Single<span>₹2000</span></li>
                  <li>Children (&lt;10 Years)<span>Free</span></li>
                  <li>Group of 3 or 4<span>₹5100</span></li>
                  <li>Children (&lt;10 Years)<span>Free</span></li>
                  </ul>
                </Box>
              </Grid>
            </Grid>
            <section>
              <Grid container spacing={2} alignItems="center" className="mt-4" justifyContent="center">
                <Grid size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }} >
                  <Box className="templeInnerHeading">
                    <h2>Plan Your Route</h2>
                  </Box>
                </Grid>


                
                  <Grid size={{ xl: 12, lg: 12, md: 12, sm: 6, xs: 12 }} >
                    <Box className="routeBox">
                      <Box className="routeInnerBox">
                        <Box className="route1">
                          <img src="../assets/route-icon/flight.svg" alt="" className='img-fluid' />
                          <h3>Flight</h3>
                        </Box>
                        <Box className="route2">
                          <img src="../assets/route-icon/border.svg" alt="" className='img-fluid' />
                        </Box>
                        <Box className="route3">
                          <p>Take Bus/Cab/ Train from jammu to reach katra.</p>
                        </Box>
                      </Box>

                      <Box className="routeInnerBox">
                        <Box className="route1">
                          <img src="../assets/route-icon/bus.svg" alt="" className='img-fluid' />
                          <h3>Bus</h3>
                        </Box>
                        <Box className="route2">
                          <img src="../assets/route-icon/border.svg" alt="" className='img-fluid' />
                        </Box>
                        <Box className="route3">
                          <p>From Jammu Tawi - 48.5 Kms,</p>
                          <p> 1 Hour 30 mins, ₹100-500</p>
                        </Box>
                      </Box>

                      <Box className="routeInnerBox">
                        <Box className="route1">
                          <img src="../assets/route-icon/texi.svg" alt="" className='img-fluid' />
                          <h3>Private Taxi</h3>
                        </Box>
                        <Box className="route2">
                          <img src="../assets/route-icon/border.svg" alt="" className='img-fluid' />
                        </Box>
                        <Box className="route3">
                          <p>From Jammu Tawi - 48.5 Kms</p>
                          <p>1 Hour approx, ₹1800-2200</p>
                        </Box>
                      </Box>

                      

                      <Box className="routeInnerBox">
                        <Box className="route1">
                          <img src="../assets/route-icon/train.svg" alt="" className='img-fluid' />
                          <h3>Train</h3>
                        </Box>
                        <Box className="route2">
                          <img src="../assets/route-icon/border.svg" alt="" className='img-fluid' />
                        </Box>
                        <Box className="route3">
                          <p className='mb-1'><span>1. Jammu Tawi Station</span> - Take Train / Bus / Cab to Katra. - 48.5 Kms, 1 Hour 30 mins</p>
                          <p><span>2. Katra Station to Bus stop</span> 1.5 Km, 5 mins, ₹100</p>
                        </Box>
                      </Box>

                      <Box className="routeInnerBox">
                        <Box className="route1">
                          <img src="../assets/route-icon/auto.svg" alt="" className='img-fluid' />
                          <h3>Autorikshaw</h3>
                        </Box>
                        <Box className="route2">
                          <img src="../assets/route-icon/border.svg" alt="" className='img-fluid' />
                        </Box>
                        <Box className="route3">
                          <p>From Katra railway station - 4 Km, 12 Mins, ₹ 150-200</p>
                        </Box>
                      </Box>


                      <Box className="routeInnerBox">
                        <Box className="route1">
                          <img src="../assets/route-icon/battry-car.svg" alt="" className='img-fluid' />
                          <h3>Battery Car</h3>
                        </Box>
                        <Box className="route2">
                          <img src="../assets/route-icon/border.svg" alt="" className='img-fluid' />
                        </Box>
                        <Box className="route3">
                          <p>₹450/- per head (Adhkuwari to Bhawan) ₹300/- Per head (Bhawan to Adhkuwari)</p>
                        </Box>
                      </Box>
                    </Box>
                  </Grid>
                


              </Grid>
            </section>
          </Container>
        </Box>
      </section>
       <Box className="lightGrayBox">
              <Container maxWidth="md">
                <Grid container spacing={2} justifyContent="center" alignItems="center">
                  <Grid size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }} >
                    <Box className="templeInnerHeading">
                      <h2>Yatra Parchi / Registration</h2>
                      <p>Yes/No with website and total registration permitted every day</p>
                    </Box>
                  </Grid>
                  <Grid size={{ xl: 4, lg: 4, md: 4, sm: 6, xs: 12 }} >
                    <Box className="registrationzBox">
                      <h2>01</h2>
                      <p>A valid Yatra slip or RFID card is mandatory. Daily registration is limited to 50,000 yatris. <span>Entry without an RFID card is strictly prohibited.</span>
                      </p>
                    </Box>
                  </Grid>
                  <Grid size={{ xl: 4, lg: 4, md: 4, sm: 6, xs: 12 }} >
                    <Box className="registrationzBox">
                      <h2>02</h2>
                      <p>
                        Vaishno Devi Yatra registration can be done at the official counter near the Katra bus stand or conveniently online through website: <Link href="">www.maavaishnodevi.org</Link>
                      </p>
                    </Box>
                  </Grid>
                  <Grid size={{ xl: 4, lg: 4, md: 4, sm: 6, xs: 12 }} >
                    <Box className="registrationzBox lastBox">
                      <h2>03</h2>
                      <p><span>Yatris must cross the first check post at Banganga (approx. 1.5 km) within 6 hours</span> of RFID card issuance. Failure to do so will result in card confiscation, and a new Yatra Access Card will be required.</p>
                    </Box>
                  </Grid>

                  
                </Grid>
              </Container>
            </Box>


      <section>
        <Container maxWidth="md">
          <Grid container spacing={2} justifyContent="center" alignItems="center">
            <Grid size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }} >
              <Box className="templeInnerHeading">
                <h2>Blessings That Attract Millions</h2>
              </Box>


            </Grid>
            <Grid size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }} >
              <Box className="templeInnerHeading mb-4">
                <h3>Peak Months</h3>
                <p>(On Daily Basis - 35K - 50K)</p>
              </Box>
            </Grid>
            
              <Grid size={{ xl: 2.4, lg: 2.4, md: 2.4, sm: 6, xs: 6 }} >
                <Box className="peakMonthBox">
                  <Box>
                    <p>April</p>
                    <span>10.2 L</span>
                  </Box>
                </Box>
              </Grid>

              <Grid size={{ xl: 2.4, lg: 2.4, md: 2.4, sm: 6, xs: 6 }} >
                <Box className="peakMonthBox">
                  <Box>
                    <p>May</p>
                    <span>10.0 L</span>
                  </Box>
                </Box>
              </Grid>

              <Grid size={{ xl: 2.4, lg: 2.4, md: 2.4, sm: 6, xs: 6 }} >
                <Box className="peakMonthBox">
                  <Box>
                    <p>June</p>
                    <span>12.0 L</span>
                  </Box>
                </Box>
              </Grid>

              <Grid size={{ xl: 2.4, lg: 2.4, md: 2.4, sm: 6, xs: 6 }} >
                <Box className="peakMonthBox">
                  <Box>
                    <p>Sep</p>
                    <span>7.9 L</span>
                  </Box>
                </Box>
              </Grid>


              <Grid size={{ xl: 2.4, lg: 2.4, md: 2.4, sm: 6, xs: 6 }} >
                <Box className="peakMonthBox">
                  <Box>
                    <p>Oct</p>
                    <span>9.2 L</span>
                  </Box>
                </Box>
              </Grid>
            

            <Grid size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }} >
              <Box className="templeInnerHeading mt-4">
                <h3>Off - Peak Months</h3>
                <p>(On Daily Basis - 13K - 15K)</p>
              </Box>
            </Grid>
            
              <Grid size={{ xl: 2.4, lg: 2.4, md: 2.4, sm: 6, xs: 6 }} >
                <Box className="offPeakMonthBox">
                  <Box>
                    <p>Jan</p>
                    <span>5.2 L</span>
                  </Box>
                </Box>
              </Grid>

              <Grid size={{ xl: 2.4, lg: 2.4, md: 2.4, sm: 6, xs: 6 }} >
                <Box className="offPeakMonthBox">
                  <Box>
                    <p>Feb</p>
                    <span>4.1 L</span>
                  </Box>
                </Box>
              </Grid>
          </Grid>
        </Container>
      </section>


      <Box className="lightGrayBox">
        <Container maxWidth="md">
          <Grid container spacing={2} justifyContent="center" alignItems="center">
            <Grid size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }} >
              <Box className="templeInnerHeading mb-lg-4">
                <h2>Accommodation Information</h2>
              </Box>
            </Grid>
            
             

              <Grid size={{ xl: 6, lg: 6, md: 6, sm: 6, xs: 12 }} >
                <Box className="accommodationBox">
                  <Box className="accommodationImg">
                    <img src="../assets/accommodation-icon/beds.svg" className='img-fluid' alt="" />
                  </Box>
                  <Box className="accommodationContent">
                      <h3>Katra - Shrine Rooms/Dormitory</h3>
                      <ul>
                        <li><span>Near:</span> Niharika, Shakti Bhawan, Trikuta Bhawan, Ashirwad Bhawan, Spiritual Growth Centre</li>
                        <li><span>Expect:</span> ₹150 to ₹3300 depending on number of beds</li>
                        <li><span>Info:</span> Dormitory (AC/Non-AC Per Bed Basis) & Rooms(AC) available. Book through SMVDSB website or at reservation counter at Niharika Complex</li>
                      </ul>
                   
                   
                  </Box>
                </Box>
              </Grid>
              
               <Grid size={{ xl: 6, lg: 6, md: 6, sm: 6, xs: 12 }} >
                <Box className="accommodationBox">
                  <Box className="accommodationImg">
                    <img src="/assets/accommodation-icon/icon1.svg" className='img-fluid' alt="" />
                  </Box>
                  <Box className="accommodationContent">
                    <h3>Hotels Available Nearby</h3>
                    <div>
                      <ul>
                        <li><span>Near:</span> Numerous hotels are available within a 5 km radius of Katra</li>
                        <li><span>Expect:</span> from ₹1000 based on facilities 2-bed AC rooms Rs2000</li>
                        <li><span>Info:</span> Hotels are readily available</li>
                      </ul>
                    </div>
                  </Box>
                </Box>
              </Grid>

              <Grid size={{ xl: 6, lg: 6, md: 6, sm: 6, xs: 12 }} >
                <Box className="accommodationBox">
                  <Box className="accommodationImg">
                    <img src="../assets/accommodation-icon/icon3.svg" className='img-fluid' alt="" />
                  </Box>
                  <Box className="accommodationContent">
                    <h3>Multiple Locations</h3>
                    <p>Rooms and dormitories are available at Jammu, Katra, Bhawan, Sanjhichatt, and Ardhkuwari.</p>
                  </Box>
                </Box>
              </Grid>

              <Grid size={{ xl: 6, lg: 6, md: 6, sm: 6, xs: 12 }} >
                <Box className="accommodationBox">
                  <Box className="accommodationImg">
                    <img src="../assets/accommodation-icon/icon4.svg" className='img-fluid' alt="" />
                  </Box>
                  <Box className="accommodationContent">
                    <h3>Room Options</h3>
                    <p>Comfortable <strong>2-bed AC rooms start at ₹2000.</strong></p>
                  </Box>
                </Box>
              </Grid>


              <Grid size={{ xl: 6, lg: 6, md: 6, sm: 6, xs: 12 }} >
                <Box className="accommodationBox">
                  <Box className="accommodationImg">
                    <img src="../assets/accommodation-icon/icon5.svg" className='img-fluid' alt="" />
                  </Box>
                  <Box className="accommodationContent">
                    <h3>Jammu - Shrine Rooms/Dormitory Facility</h3>
                    <ul>
                        <li><span>Near:</span> Vaishnavi Dham, Kalika Dham, Saraswati Dham</li>
                        <li><span>Expect:</span> ₹150 to ₹2000 depending on number of beds</li>
                        <li><span>Info:</span> Dormitory (AC/Non-AC Per Bed Basis) & Rooms(AC) available. Book through SMVDSB website or at reservation counter at Niharika Complex</li>
                      </ul>
                  </Box>
                </Box>
              </Grid>
              

              

              <Grid size={{ xl: 6, lg: 6, md: 6, sm: 6, xs: 12 }} >
                <Box className="accommodationBox">
                  <Box className="accommodationImg">
                    <img src="../assets/accommodation-icon/beds.svg" className='img-fluid' alt="" />
                  </Box>
                  <Box className="accommodationContent">
                    <h3>Ardhkuwari - Shrine Rooms/dormitory Facility</h3>
                    <ul>
                        <li><span>Near:</span> Sharda Bhawan, Shailputri Bhawan</li>
                        <li><span>Expect:</span> ₹150 to ₹800 depending on number of beds</li>
                        <li><span>Info:</span> Dormitory (Non-AC Per Bed Basis) & Rooms(Non-AC) available. Book through SMVDSB website or at reservation counter at Niharika Complex</li>
                      </ul>
                    
                  </Box>
                </Box>
              </Grid>

              <Grid size={{ xl: 6, lg: 6, md: 6, sm: 6, xs: 12 }} >
                <Box className="accommodationBox">
                  <Box className="accommodationImg">
                    <img src="../assets/accommodation-icon/beds.svg" className='img-fluid' alt="" />
                  </Box>
                  <Box className="accommodationContent">
                    <h3>Sanjichhat - Shrine Rooms/Dormitory Facility</h3>
                     <ul>
                        <li><span>Near:</span> Mangla Bhawan</li>
                        <li><span>Expect:</span> ₹150 to ₹1200 depending on number of beds</li>
                        <li><span>Info:</span> Dormitory (Non-AC Per Bed Basis) & Rooms(Non-AC) available. Book through SMVDSB website or at reservation counter at Niharika Complex</li>
                      </ul>
                  </Box>
                </Box>
              </Grid>

              <Grid size={{ xl: 6, lg: 6, md: 6, sm: 6, xs: 12 }} >
                <Box className="accommodationBox">
                  <Box className="accommodationImg">
                    <img src="../assets/accommodation-icon/beds.svg" className='img-fluid' alt="" />
                  </Box>
                  <Box className="accommodationContent">
                    <h3>Bhawan - Shrine Rooms/Dormitory Facility</h3>
                    <ul>
                        <li><span>Near:</span> Main Bhawan complex, Vaishnavi & Gouri Bhawan, Manokamana Bhawan</li>
                        <li><span>Expect:</span> ₹150 to ₹3400 depending on number of beds</li>
                        <li><span>Info:</span> Dormitory (Non-AC Per Bed Basis) & Rooms(Non-AC) available. Book through SMVDSB website or at reservation counter at Niharika Complex</li>
                      </ul>
                    
                  
                    
                  </Box>
                </Box>
              </Grid>

              <Grid size={{ xl: 6, lg: 6, md: 6, sm: 6, xs: 12 }} >
                <Box className="accommodationBox">
                  <Box className="accommodationImg">
                    <img src="../assets/accommodation-icon/beds.svg" className='img-fluid' alt="" />
                  </Box>
                  <Box className="accommodationContent">
                      <h3>Vaishnavi and Gouri Bhawan</h3>
                    <p className='mb-0'>Double bedded - ₹1100</p>
                    <p className='mb-0'>Four bedded -  ₹1600</p>
                    <p className='mb-0'>Six bedded hut	- ₹2300</p>
                  </Box>
                </Box>
              </Grid>

              <Grid size={{ xl: 6, lg: 6, md: 6, sm: 6, xs: 12 }} >
                <Box className="accommodationBox">
                  <Box className="accommodationImg">
                    <img src="../assets/accommodation-icon/beds.svg" className='img-fluid' alt="" />
                  </Box>
                  <Box className="accommodationContent">
                      <h3>New Vaishnavi Bhawan</h3>
                    <p className='mb-0'>Double bedded - ₹2,250</p>
                    <p className='mb-0'>Four bedded - ₹3,190</p>
                    <p className='mb-0'>Six bedded	- ₹5400</p>
                  </Box>
                </Box>
              </Grid>
              

              <Grid size={{ xl: 6, lg: 6, md: 6, sm: 6, xs: 12 }} >
                <Box className="accommodationBox">
                  <Box className="accommodationImg">
                    <img src="../assets/accommodation-icon/icon2.svg" className='img-fluid' alt="" />
                  </Box>
                  <Box className="accommodationContent">
                    <h3>Affordable Tariffs</h3>
                    <p>Prices start from ₹1000 and vary based on the type of accommodation</p>
                  </Box>
                </Box>
              </Grid>

              <Grid size={{ xl: 6, lg: 6, md: 6, sm: 6, xs: 12 }} >
                <Box className="accommodationBox">
                  <Box className="accommodationImg">
                    <img src="../assets/accommodation-icon/icon6.svg" className='img-fluid' alt="" />
                  </Box>
                  <Box className="accommodationContent">
                    <h3>Security Deposit</h3>
                    <p>A deposit is required at check-in for all accommodations</p>
                  </Box>
                </Box>
              </Grid>

              <Grid size={{ xl: 6, lg: 6, md: 6, sm: 6, xs: 12 }} >
                <Box className="accommodationBox">
                  <Box className="accommodationImg">
                    <img src="../assets/accommodation-icon/beds.svg" className='img-fluid' alt="" />
                  </Box>
                  <Box className="accommodationContent">
                      <h3>Katra, spiritual growth centre</h3>
                    <p className='mb-0'>Double bedded - ₹1900</p>
                    <p className='mb-0'>Suite- ₹3300</p>
                   
                  </Box>
                </Box>
              </Grid>


              <Grid size={{ xl: 6, lg: 6, md: 6, sm: 6, xs: 12 }} >
                
              </Grid>
            

          </Grid>
        </Container>
      </Box>
<section className='pb-0 '>
        <Container maxWidth="md">
          <Grid container spacing={2} justifyContent="center" alignItems="center">
          <Grid size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }}>
           <Box className="templeInnerHeading">
                <h2>Special Packages</h2>
              </Box>
                    <div className="yatra-packages container py-3 d-flex flex-wrap justify-content-center gap-4">
      {packages.map((pkg, index) => (
        <div className="package-card shadow" key={index}>
          <div
            className="package-header text-white text-center py-3"
            style={{ background: pkg.gradient }}
          >
            <h5 className="mb-0">{pkg.type}</h5>
            <small>{pkg.subtitle}</small>
          </div>

          <div className="package-body text-center p-4">
            <h2 className="price mb-3">{pkg.price}</h2>
            <ul className="feature-list list-unstyled">
              {pkg.features.map((feature, i) => (
                <li key={i}>
                  <i className='fa fa-check icon'></i>
                  {feature}
                </li>
              ))}
            </ul>
            <a href="https://online.maavaishnodevi.org/#/helicopter" target="_blank" className="btn btn-outline-dark rounded-pill mt-4">
              Enquire now
            </a>
          </div>
        </div>
      ))}
    </div>
          </Grid>
            </Grid>
          </Container>
          </section>
      <section>
        <Container maxWidth="md">
          <Grid container spacing={2} justifyContent="center" alignItems="stretch">
            <Grid size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }} >
              <Box className="templeInnerHeading mb-lg-4">
                <h2>Here’s What You Should Know</h2>
              </Box>
            </Grid>
            <Grid size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }} >
              <div className='infoGuideBox'>
                <Grid container spacing={2} justifyContent="center" alignItems="center">
                  <Grid size={{ xl: 3, lg: 3, md: 3, sm: 12, xs: 12 }} >
                    <div className='infoHeading'>

                      <h2>01</h2>
                      <h3>Clothing Guidelines</h3>

                    </div>
                  </Grid>

                  <Grid size={{ xl: 9, lg: 9, md: 9, sm: 12, xs: 12 }} >
                    <div className='infoList'>
                      <ul>
                        <li>Avoid shorts or revealing clothes.</li>
                        <li>Warm clothes are advisable—even on sunny days.</li>
                        <li>Late July to Early September: Pack a raincoat and umbrella for surprise showers.</li>
                        <li>December to January: Bring heavy woollens, wind-cheaters, caps, and gloves for warmth.</li>
                      </ul>
                    </div>
                  </Grid>
                </Grid>
              </div>



            </Grid>


            <Grid size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }} >
              <div className='infoGuideBox'>
                <Grid container spacing={2} justifyContent="center" alignItems="center">
                  <Grid size={{ xl: 3, lg: 3, md: 3, sm: 12, xs: 12 }} >
                    <div className='infoHeading'>

                      <h2>02</h2>
                      <h3>Entry/Exit Information</h3>

                    </div>
                  </Grid>

                  <Grid size={{ xl: 9, lg: 9, md: 9, sm: 12, xs: 12 }} >
                    <div className='infoList'>
                      <h4>Entry Gates:</h4>
                      <ul>
                        <li><span>Gate 1 :</span> Near Old Gufa – Restricted, no public access</li>
                        <li><span>Gate 2 :</span> Near Kalika Bhawan – VIP and Aarti pass holders</li>
                        <li><span>Gate 3 :</span> Via Skywalk – General public via Skywalk</li>
                        <li><span>Gate 4 :</span> Near Ambe Smart Locker – Emergency only near Arya Smart Locker (no public access)</li>
                        <li><span>Gate 5 :</span> Near Durga Bhawan – Defence personnel only near Durga Bhawan</li>
                        <li><span>Gate 6 :</span> Near Hanuman Mandir – Emergency only near Hanuman Mandir (no public access)</li>
                      </ul>
                      <h4 className="mt-2">Exit Gates:</h4>
                      <p>Entry and exit through the same gate via separate routes</p>
                    </div>
                  </Grid>
                </Grid>
              </div>



            </Grid>



            <Grid size={{ xl: 6, lg: 6, md: 6, sm: 12, xs: 12 }} >
              <div className='infoGuideBox'>
                <Grid container spacing={2} justifyContent="center" alignItems="center">
                  <Grid size={{ xl: 7, lg: 7, md: 7, sm: 12, xs: 12 }} >
                    <div className='infoHeading'>

                      <h2>03</h2>
                      <h3>Photography / Videography</h3>

                    </div>
                  </Grid>

                  <Grid size={{ xl: 5, lg: 5, md: 5, sm: 12, xs: 12 }} >
                    <div className='infoList'>

                      <p>Not allowed inside bhawan</p>
                    </div>
                  </Grid>
                </Grid>
              </div>



            </Grid>


            <Grid size={{ xl: 6, lg: 6, md: 6, sm: 12, xs: 12 }} >
              <div className='infoGuideBox'>
                <Grid container spacing={2} justifyContent="center" alignItems="center">
                  <Grid size={{ xl: 7, lg: 7, md: 7, sm: 12, xs: 12 }} >
                    <div className='infoHeading'>

                      <h2>04</h2>
                      <h3>Drinking Water & Restrooms</h3>

                    </div>
                  </Grid>

                  <Grid size={{ xl: 5, lg: 5, md: 5, sm: 12, xs: 12 }} >
                    <div className='infoList'>

                      <p>Free water available every 500 meters along the track</p>
                    </div>
                  </Grid>
                </Grid>
              </div>



            </Grid>


            <Grid size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }} >
              <div className='infoGuideBox'>
                <Grid container spacing={2} justifyContent="center" alignItems="center">
                  <Grid size={{ xl: 7, lg: 7, md: 7, sm: 12, xs: 12 }} >
                    <Grid container spacing={2} justifyContent="center" alignItems="center">
                      <Grid size={{ xl: 5, lg: 5, md: 5, sm: 12, xs: 12 }} >
                        <div className='infoHeading'>
                          <h2>05</h2>
                          <h3>VIP Darshan</h3>
                        </div>
                      </Grid>

                      <Grid size={{ xl: 7, lg: 7, md: 7, sm: 12, xs: 12 }} >
                        <div className='infoList'>
                          <h4>Defence Personnel:</h4>
                          <ul>
                            <li>Cost: Complimentary</li>
                            <li>Pass: Available at the Army counter near Shiv Temple</li>
                          </ul>
                        </div>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid size={{ xl: 5, lg: 5, md: 5, sm: 12, xs: 12 }} >
                    <div className='infoList'>
                      <h4>General Public (Helicopter Yatris Only):</h4>
                      <ul>
                        <li>Katra–Sanjichhat: ₹2210</li>
                        <li>Sanjichhat–Katra: ₹2210</li>
                        <li>Round Trip: ₹3660</li>
                      </ul>
                    </div>
                  </Grid>
                </Grid>

              </div>



            </Grid>


            <Grid size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }} >
              <div className='infoGuideBox'>
                <Grid container spacing={2} justifyContent="center" alignItems="center">
                  <Grid size={{ xl: 3, lg: 3, md: 3, sm: 12, xs: 12 }} >
                    <div className='infoHeading'>
                      <h2>06</h2>
                      <h3>Smart Locker / Cloak Room</h3>
                    </div>
                  </Grid>

                  <Grid size={{ xl: 9, lg: 9, md: 9, sm: 12, xs: 12 }} >
                    <p>Available at Adhkuwari (1) and Bhawan(3) Book through Mandirwiki App or whatsapp (9625974411 / 8596869207) or at booking counter available near locker banks.</p>
                    <div className='infoList'>
                      <ul>
                      <li>Safe and secure smart lockers available at on RS.50 for 3 hours (₹15 per hour overstay penalty applicable)</li>
                        <li>Free locker available Inside Temple premises near Gate No 1</li>
                        <li>Local shops also offer storage for a nominal fee.</li>
                      </ul>
                    </div>
                  </Grid>
                </Grid>
              </div>



            </Grid>


            <Grid size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }} >
              <div className='infoGuideBox'>
                <Grid container spacing={2} justifyContent="center" alignItems="center">
                  <Grid size={{ xl: 3, lg: 3, md: 3, sm: 12, xs: 12 }} >
                    <div className='infoHeading'>
                      <h2>07</h2>
                      <h3>Shoe Storage</h3>
                    </div>
                  </Grid>

                  <Grid size={{ xl: 9, lg: 9, md: 9, sm: 12, xs: 12 }} >
                    <div className='infoList'>
                      <ul>
                        <li>Available for free at Ardhkwari and Bhawan.</li>
                        <li>Local shops also offer storage for a nominal fee.</li>
                      </ul>
                    </div>
                  </Grid>
                </Grid>
              </div>



            </Grid>


            <Grid size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }} >
              <div className='infoGuideBox'>
                <Grid container spacing={2} justifyContent="center" alignItems="center">
                  <Grid size={{ xl: 3, lg: 3, md: 3, sm: 12, xs: 12 }} >
                    <div className='infoHeading'>
                      <h2>08</h2>
                      <h3>Parking</h3>
                    </div>
                  </Grid>

                  <Grid size={{ xl: 9, lg: 9, md: 9, sm: 12, xs: 12 }} >
                    <div className='infoList'>
                      <ul>
                        <li>Katra Railway Station, ₹50 approx</li>
                      </ul>
                    </div>
                  </Grid>
                </Grid>
              </div>



            </Grid>


            <Grid size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }} >
              <div className='infoGuideBox'>
                <Grid container spacing={2} justifyContent="center" alignItems="center">
                  <Grid size={{ xl: 3, lg: 3, md: 3, sm: 12, xs: 12 }} >
                    <div className='infoHeading'>
                      <h2>09</h2>
                      <h3>Mobile & Smart watch locker</h3>
                    </div>
                  </Grid>

                  <Grid size={{ xl: 9, lg: 9, md: 9, sm: 12, xs: 12 }} >
                    <p>Available at Durga Bhawan(1). Book through whatsapp (9596869207) or at booking counter available at durga bhawan.</p>
                    <div className='infoList'>
                      <ul>
                        <li><span>Location</span> : Durga Bhawan Ground Floor</li>
                      </ul>
                    </div>
                  </Grid>
                </Grid>
              </div>



            </Grid>


            <Grid size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }} >
              <div className='infoGuideBox'>
                <Grid container spacing={2} justifyContent="center" alignItems="center">
                  <Grid size={{ xl: 3, lg: 3, md: 3, sm: 12, xs: 12 }} >
                    <div className='infoHeading'>
                      <h2>10</h2>
                      <h3>Bhojanalayas</h3>
                    </div>
                  </Grid>

                  <Grid size={{ xl: 9, lg: 9, md: 9, sm: 12, xs: 12 }} >
                    <p>The Bhojanalyas at Bhawan run round the clock and serve a varied but traditional menu.</p>
                    <div className='infoList'>
                      <ul>
                        <li><span>Location</span> : Available at Adhkuwari (1) SanjiChhat (1) Bhawan (3)</li>
                        <li><span>Price</span> : Cheap and Affordable rates</li>
                      </ul>
                    </div>
                  </Grid>
                </Grid>
              </div>



            </Grid>


            <Grid size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }} >
              <div className='infoGuideBox'>
                <Grid container spacing={2} justifyContent="center" alignItems="center">
                  <Grid size={{ xl: 3, lg: 3, md: 3, sm: 12, xs: 12 }} >
                    <div className='infoHeading'>
                      <h2>11</h2>
                      <h3>Blanket Store</h3>
                    </div>
                  </Grid>

                  <Grid size={{ xl: 9, lg: 9, md: 9, sm: 12, xs: 12 }} >
                    <p>The Shrine Board has arranged for free blanket stores at various location. For a nominal and refundable security deposit. yatires are issued blankets for the night</p>
                    <div className='infoList'>
                      <ul>
                        <li><span>Location</span> : Vaishnavi Dham (Jammu), Katra Bus Stand, Adhkuwari, Sanjichhat and Bhawan</li>
                        <li><span>Price</span> : Based on item.</li>
                      </ul>
                    </div>
                  </Grid>
                </Grid>
              </div>



            </Grid>

            <Grid size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }} >
              <div className='infoGuideBox'>
                <Grid container spacing={2} justifyContent="center" alignItems="center">
                  <Grid size={{ xl: 3, lg: 3, md: 3, sm: 12, xs: 12 }} >
                    <div className='infoHeading'>
                      <h2>12</h2>
                      <h3>Shoe stand</h3>
                    </div>
                  </Grid>

                  <Grid size={{ xl: 9, lg: 9, md: 9, sm: 12, xs: 12 }} >
                    <p>Available at Adhkuwari and Bhawan (Free) Local Shops also provide at nominal fee.</p>
                    
                  </Grid>
                </Grid>
              </div>



            </Grid>

          </Grid>
        </Container>
      </section>

 

      <section className="lightGrayBox">
        <Container maxWidth="md">
          <Grid container spacing={2} justifyContent="center" alignItems="center">
            <Grid size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }} >
              <Box className="templeInnerHeading mb-lg-4">
                <h2>Explore Nearby</h2>
              </Box>
            </Grid>
            <Grid size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }} >
              <Box className="explore-nearby">
                <Grid container spacing={2}>
                  {/* Left Column */}
                  <Grid size={{ xl: 7, lg: 7, md: 7, sm: 12, xs: 12 }}>
                    <Box className="info-box">
                      <Typography className="title">Tourist Attractions</Typography>
                      <div className="block">
                        <span>Mantalai</span>
                        <p>92.5 km from Jammu (approx. 2 hrs by cab)</p>
                        <p>63.9 km from Katra (approx. 1.5 hrs by cab)</p>
                      </div>
                      <div className="block">
                        <span>Patnitop</span>
                        <p>112 km from Jammu (approx. 2 hrs 40 mins by cab)</p>
                        <p>84.4 km from Katra (approx. 2 hrs 15 mins by cab)</p>
                      </div>
                      <div className="block">
                        <span>Sanansar</span>
                        <p>131 km from Jammu (approx. 3.5 hrs by cab)</p>
                        <p>20 km from Patnitop (approx. 50 mins by cab)</p>
                      </div>
                    </Box>

                    <Box className="info-box mt-3">
                      <Typography className="title">ATM & Banks</Typography>
                      <p><span>Katra</span> – OBC, UCO Bank, J&K Bank, Ellaqui Dehati Bank</p>
                      <p><span>Adhkuwari</span> – J&K Bank</p>
                      <p><span>Bhawan</span> – OBC, J&K Bank</p>
                    </Box>

                    <Box className="info-box mt-3">
                      <Typography className="title">VIP Darshan</Typography>
                      <p>Free for Defence (pass at Army counter near Shiv Temple).</p>
                      <p>Free for Helicopter Yatris, and for those availing Attka Aarti, Garbhjoon Aarti, SSVP, Nav Chandi Path, and Havan Pooja services.</p>
                      <p><span>Price</span> – ₹ 1830 (One-way Katra-sanjichaat) / ₹3660 round trip</p>
                    </Box>
                  </Grid>

                  

                  {/* Right Column */}
                  <Grid size={{ xl: 5, lg: 5, md: 5, sm: 12, xs: 12 }}>
                    <Grid container spacing={2}>
                      <Grid size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }}>
                        <Box className="info-box">
                          <Typography className="title">Food/Restaurant</Typography>
                          <p>Adkuwari – 1</p>
                          <p>Sanjichhat – 1</p>
                          <p>Bhawan – 3</p>
                        </Box>
                      </Grid>
                      <Grid size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }}>
                        <Box className="info-box">
                          <Typography className="title">Hospital</Typography>
                          <p>Katra Hospital (1 km)</p>
                          <p>Bhawan Hospital (3 km)</p>
                        </Box>
                      </Grid>
                      <Grid size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }}>
                        <Box className="info-box">
                          <Typography className="title">Medical Services</Typography>
                          <p>Block Hospital at Katra, Basic medical facilities at Banganga. Adhkuwari, Sanjichhat, and Bhawan, 24×7 ICU at Bhawan. Specialised and advanced medical treatment is available only at Jammu</p>
                          <p><span>Vaishno Devi Medicals (0.4 km)</span></p>
                          <p><span>Cave Pharmacy (0.3 km)</span></p>
                        </Box>
                      </Grid>
                      <Grid size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }}>
                        <Box className="info-box">
                          <Typography className="title">Toilets</Typography>
                          <p>Free Toilets available every 500 meters along the track</p>
                        </Box>
                      </Grid>
                      
                    </Grid>
                  </Grid>
                </Grid>
              </Box>
            </Grid>


            

          </Grid>
        </Container>
      </section>

      

      <section>
        <Container maxWidth="md">
          <Grid container spacing={2} justifyContent="center" alignItems="center">
            <Grid size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }} >
              <Box className="templeInnerHeading">
                <h2>Special Services</h2>
                <p>Special services to make your Vaishno Devi journey smoother and more accessible</p>
              </Box>
            </Grid>
            <Grid size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }} >
              <div className="paliBox rounded-4 overflow-hidden">
                <div id="carouselExampleIndicators" className="carousel slide" data-bs-ride="carousel">
                  <div className="carousel-indicators">
                    {carouselItems.map((_, i) => (
                      <button
                        key={i}
                        type="button"
                        data-bs-target="#carouselExampleIndicators"
                        data-bs-slide-to={i}
                        className={i === 0 ? 'active' : ''}
                        aria-current={i === 0 ? 'true' : undefined}
                        aria-label={`Slide ${i + 1}`}
                      ></button>
                    ))}
                  </div>

                  <div className="carousel-inner">
                    {carouselItems.map((item, i) => (
                      <div key={i} className={`carousel-item ${i === 0 ? 'active' : ''}`}>
                        <img src={item.image} className="d-block w-100" alt={item.title} />
                        {item.title && (
                          <div className="carouselStrip">
                            <p>{item.title}</p>
                            {item.note && <span>{item.note}</span>}
                          </div>
                        )}
                        <div className="carouselList">
                          {Array.isArray(item.content) ? (
                            <ul className={item.content.length > 4 ? 'listFlex' : ''}>
                              {item.content.map((sub, j) =>
                                typeof sub === 'string' ? (
                                  <li key={j}>{sub}</li>
                                ) : (
                                  <li key={j}>
                                    {sub.title}
                                    <ul>
                                      {sub.prices.map((price, k) => (
                                        <li key={k}>{price}</li>
                                      ))}
                                    </ul>
                                  </li>
                                )
                              )}
                            </ul>
                          ) : null}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>

            </Grid>

          </Grid>
        </Container>
      </section>

       


      <section className='p-0 mt-5'>
        <Container maxWidth="md">
          <Grid container spacing={2} justifyContent="center" alignItems="center">
            <Grid size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }}>
              <Box className="templeInnerHeading mb-lg-1">
                <h2>Temple track</h2>
              </Box>
            </Grid>


            <Grid size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }}>
              <ul className="nav nav-tabs treckTab" id="myTab" role="tablist">
                <li className="nav-item" role="presentation">
                  <button className="nav-link active" id="home-tab" data-bs-toggle="tab" data-bs-target="#home" type="button" role="tab" aria-controls="home" aria-selected="true">Old Track</button>
                </li>
                <li className="nav-item" role="presentation">
                  <button className="nav-link" id="profile-tab" data-bs-toggle="tab" data-bs-target="#profile" type="button" role="tab" aria-controls="profile" aria-selected="false">New Track</button>
                </li>
                <li className="nav-item" role="presentation">
                  <button className="nav-link" id="contact-tab" data-bs-toggle="tab" data-bs-target="#contact" type="button" role="tab" aria-controls="contact" aria-selected="false">Helicopter Route</button>
                </li>
              </ul>

            </Grid>

          </Grid>
          
          <div className="tab-content" id="myTabContent">
            <div className="tab-pane fade show active rounded-4 overflow-hidden" id="home" role="tabpanel" aria-labelledby="home-tab">
              <img src="../assets/treks/old-trek.jpeg" className='img-fluid w-100 rounded-4' alt="" />
            </div>
            <div className="tab-pane fade rounded-4 overflow-hidden" id="profile" role="tabpanel" aria-labelledby="profile-tab">
              <img src="../assets/treks/new-trek.jpeg" className='img-fluid w-100 rounded-4' alt="" />
            </div>
            <div className="tab-pane fade rounded-4 overflow-hidden" id="contact" role="tabpanel" aria-labelledby="contact-tab">
              <img src="../assets/treks/helicopter-route.jpg" className='img-fluid w-100 rounded-4' alt="" />
            </div>
          </div>
        </Container>
      </section>


    </>
  );
}
export default Detail;